/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes, { any } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../components/Modal/ReactBootstrapModal';

import AllPlayersItemV3 from './AllPlayersItemV3';
import AllPlayersTeamItemV3 from './AllPlayersTeamItemV3';
import Img from '../../../components/Img';
import ColumnHeader, { SortType } from '../../../components/ColumnHeader';
import PlayerWildcardPopup from '../../EventProfiles/PlayerWildcardPopup';
import ContactForm from '../ContactForm';

import { allowDrawCreation } from '../../../utils/draws';
import { getSmsSendingAvailability } from '../../../utils/eventSmsAvailability';
import { gameTypeValues } from '../../../utils/eventConstants';
import * as drawEditActions from '../../../actions/draw-edit-actions';

import { isPickleBallSportTypeEvent, isTennisSportTypeEvent } from '../../../utils/events';
import { sortParamTypes } from '../../../utils/constants';
import withAuth from '../../../components/hocs/withAuth';
import { useStatsig } from '../../../components/hooks/useStatsig';

import styles from '../drawEdit.scss';

const AllPlayersListV3 = (props) => {
    const { eventId,
        utrType,
        sendMessage,
        setMove,
        sportTypeId,
        showHighSchoolName,
        filters,
        filteredSortedTeams,
        filteredSortedPlayers,
        maxSortedTeams,
        maxSortedPlayers,
        setSortState,
        sortState,
        hasLoadMore,
        setHasLoadMore,
        isLoading,
        hasLoadMoreButton,
        isFlexLeagueEvent,
    } = props;
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { acceptance, organizerRatings, playersDict, playersDictByMemberId, selected, selectedTeams, drawsDict, event } = useSelector(({ drawEdit }) => {
        const { acceptance, organizerRatings, players, selected, selectedTeams, event, draws } = drawEdit;
        return {
            acceptance,
            organizerRatings,
            playersDict: players.playersDict,
            playersDictByMemberId: players.playersDictByMemberId,
            selected,
            selectedTeams,
            divisionsDict: event.divisionsDict,
            drawsDict: draws.drawsDict,
            event: event.data,
        };
    });
    const dispatch = useDispatch();
    const { checkGate, featureGates } = useStatsig();
    const showSaveBookmark = checkGate(featureGates.SAVED_PLAYER_LIST_ROLLOUT);

    const { types: { tms: { division: { tournament: { acceptanceListWildcardStates } } } } } = coreUI;

    const [playerWildcardPopup, setPlayerWildcardPopup] = useState({ show: false, memberId: null });
    const [ratingExceptionPopup, setRatingExceptionPopup] = useState({ show: false, memberId: null, type: null, rating: null });
    const [showContactForm, setShowContactForm] = useState(false);

    const smsAvailability = useMemo(() => getSmsSendingAvailability(event), [event]);

    const filteredPlayers = hasLoadMore ? maxSortedPlayers : filteredSortedPlayers;
    const filteredTeams = hasLoadMore ? maxSortedTeams : filteredSortedTeams;
    const showLoadMoreBtn = hasLoadMoreButton && !isLoading && !hasLoadMore;
    const allTeams = useSelector((state) => state.drawEdit.teams).data;

    useEffect(() => {
        // clear selection on playerType change
        if (filters.playerType === gameTypeValues.SINGLES && selectedTeams.length) {
            dispatch(drawEditActions.setSelectedTeams([]));
        } else if (filters.playerType === gameTypeValues.DOUBLES && selected.length) {
            dispatch(drawEditActions.setSelected([]));
        }
    }, [filters.playerType]);

    const isSingles = !filters.playerType || filters.playerType === gameTypeValues.SINGLES;

    const togglePlayerSelect = (id) => {
        dispatch(drawEditActions.setResetTimer(true));
        const idx = selected.indexOf(id);
        if (idx > -1) {
            dispatch(drawEditActions.setSelected([...selected.slice(0, idx), ...selected.slice(idx + 1)]));
        } else {
            dispatch(drawEditActions.setSelected([...selected, id]));
        }
    };

    const toggleTeamSelect = (id) => {
        dispatch(drawEditActions.setResetTimer(true));
        const idx = selectedTeams.indexOf(id);
        if (idx > -1) {
            dispatch(drawEditActions.setSelectedTeams([...selectedTeams.slice(0, idx), ...selectedTeams.slice(idx + 1)]));
        } else {
            dispatch(drawEditActions.setSelectedTeams([...selectedTeams, id]));
        }
    };

    const toggleSelectAll = (arr) => {
        dispatch(drawEditActions.setResetTimer(true));

        if (arr.length) {
            if (selected.length === arr.length || selectedTeams.length === arr.length) {
                dispatch(drawEditActions.setSelected([]));
                dispatch(drawEditActions.setSelectedTeams([]));
            } else {
                const ids = arr.map(el => el.id || el.memberId);
                if (filteredTeams.length) {
                    dispatch(drawEditActions.setSelectedTeams(ids));
                } else {
                    dispatch(drawEditActions.setSelected(ids));
                }
            }
        }
    };

    const handleToggleAllClick = () => {
        setHasLoadMore(true);
        toggleSelectAll(maxSortedTeams?.length ? maxSortedTeams : maxSortedPlayers);
    };

    const onSelectEveryPlayerClick = () => {
        dispatch(drawEditActions.setSelected(filteredPlayers.map(p => p.memberId)));
    };

    const onClearSelectionClick = () => {
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        setHasLoadMore(false);
    };

    const handleLoadMore = () => {
        setHasLoadMore(true);
    };

    const allIsSelected = () => {
        if (selected?.length || selectedTeams?.length) {
            return filteredTeams?.length ? filteredTeams.length === selectedTeams.length : filteredPlayers?.length === selected.length;
        }
        return false;
    };

    const showMoveModal = () => {
        let fromDrawId;
        if (filters.selectedDraws.length === 1) {
            [fromDrawId] = filters.selectedDraws;
        }
        dispatch(drawEditActions.setResetTimer(true));
        if (selected.length || selectedTeams.length) {
            setMove({
                copy: true,
                showModal: true,
                fromDrawId,
                allPlayersTab: true,
            });
        }
    };

    const closePlayerWildcardPopup = () => {
        setPlayerWildcardPopup({ show: false, memberId: null });
    };

    const submitPlayerWildcard = ({ memberId, wildcardStateId }) => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.setPlayerWildcard({ eventId, divisionId: filters.selectedDivs[0], memberId, wildcardStateId }));
        closePlayerWildcardPopup();
    };

    const closeOrganizerRatingPopup = () => {
        setRatingExceptionPopup({ show: false, memberId: null, rating: null });
    };

    const saveOrganizerRatings = async (memberId, type, rating) => {
        let singlesRating;
        let doublesRating;

        if (type === 'singles') {
            singlesRating = rating;
            doublesRating = organizerRatings?.find(o => o.memberId === memberId)?.doublesOrganizerRating;
        } else {
            singlesRating = organizerRatings?.find(o => o.memberId === memberId)?.singlesOrganizerRating;
            doublesRating = rating;
        }
        await dispatch(drawEditActions.setOrganizerRating({ eventId, memberId, singlesRating, doublesRating })); // NOSONAR — Redux thunk returns a promise
        await dispatch(drawEditActions.getOrganizerRatings({ eventId })); // NOSONAR — Redux thunk returns a promise
        closeOrganizerRatingPopup();
    };

    const submitOrganizerRatings = async (memberId, type, rating, showPopup = false) => {
        if (showPopup) {
            return setRatingExceptionPopup({ show: true, memberId, type, rating });
        }

        saveOrganizerRatings(memberId, type, rating);
    };

    const playerOptions = [];
    if (filters.selectedDivs.length === 1) {
        playerOptions.push({ value: 'tag', label: 'Tag Player' });
    }

    const playerMenuOnSelected = (e, playerId, selectedOption) => {
        switch (selectedOption.value) {
            case 'tag': {
                const player = playersDict[playerId];
                setPlayerWildcardPopup({
                    show: true,
                    memberId: player.memberId,
                });
                break;
            }
            default:
                // Do nothing
                break;
        }
    };

    const openContactSidePanel = () => {
        setShowContactForm(true);
    };

    const closeSidePanel = () => {
        setShowContactForm(false);
    };

    const membersList = useMemo(() => {
        return allTeams?.reduce((members, team) => {
                if (selectedTeams?.includes(team?.id)) {
                    return members?.concat(team?.members);
                }
                return members;
            }, []);
    }, [allTeams, selectedTeams]);
    const selectedCount = isSingles ? selected.length : selectedTeams.length;
    const showContact = selected.length > 0 || selectedTeams.length > 0;
    const totalCount = isSingles ? filteredPlayers.length : filteredTeams.length;
    const showPlayerMenuOptions = filters.selectedDivs.length === 1 && acceptance?.[filters.selectedDivs[0]]?.loaded;
    const isOneDivisionSelected = filters.selectedDivs.length === 1;

    return (
        <div className={`${styles.section} bg-transparent main-content`} data-testid="draw-edit.players">
            <div className="row">
                <div className="col-md-12">
                    <div className="all-players-header small text-medium d-flex aic">
                        <div className={`align-items-center ${allIsSelected() ? 'selected' : ''}`}>
                            <div className="checkbox-wrapper">
                                <div className={`checkbox-check clickable`} onClick={handleToggleAllClick} data-testid="draw-edit.players.select-all-checkbox"><Img src="/img/icons/checkmark-icon.svg" /></div>
                            </div>
                        </div>
                        {!!selectedCount ? (
                            <div className="flex-grow">
                                <div className="row text-small text-medium no-wrap lh1-5">
                                    <span className="text-dark mr16 ml8" data-testid="draw-edit.players.selected-count">{selectedCount} selected</span>
                                    {allIsSelected() ? <span className="link clickable" onClick={onClearSelectionClick} data-testid="draw-edit.players.clear-selection-btn">Clear selection</span> : <span className="link clickable" onClick={onSelectEveryPlayerClick} data-testid="draw-edit.players.select-all-btn">Select all players</span>}
                                    &nbsp;
                                    {allowDrawCreation(event) && (<>|&nbsp;<span className="link clickable" onClick={() => showMoveModal()} data-testid="draw-edit.players.add-to-btn">Add to...</span></>)}
                                    &nbsp;
                                    {showContact && (<>|&nbsp;<span className="link clickable" onClick={openContactSidePanel} data-testid="draw-edit.players.contact-btn">Contact</span></>)}
                                </div>
                            </div>
                        ) : (
                            <div className="row flex-1">
                                <div className={`col-md-5`}>
                                    <div className="row">
                                        <div className={'col-md-3'}>
                                            <ColumnHeader
                                                isSortable
                                                columnName={`Name ${selectedCount ? '(' + selectedCount + '/' + totalCount + ')' : ''}`}
                                                isSelected={sortState.sortParam === sortParamTypes.NAME}
                                                sortType={sortState.sortType}
                                                initialSort={SortType.ASC}
                                                onClick={(srtType) => {
                                                    setSortState({
                                                        sortParam: sortParamTypes.NAME,
                                                        sortType: srtType,
                                                    });
                                                }}
                                                data-testid="draw-edit.players.col-name"
                                            />
                                        </div>
                                        {isTennisSportTypeEvent(sportTypeId) && (
                                            <>
                                                <div className="col-md-2">
                                                    <ColumnHeader
                                                        isSortable
                                                        columnName="Singles"
                                                        className={`${styles.noWrap} ${styles.jcc}`}
                                                        isSelected={sortState.sortParam === sortParamTypes.SINGLESUTR}
                                                        sortType={sortState.sortType}
                                                        onClick={(srtType) => {
                                                            setSortState({
                                                                sortParam: sortParamTypes.SINGLESUTR,
                                                                sortType: srtType,
                                                            });
                                                        }}
                                                        imgUrl="/img/v3/icons/icon-singles-black.svg"
                                                        data-testid="draw-edit.players.col-singles-utr"
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <ColumnHeader
                                                        isSortable
                                                        columnName="Doubles"
                                                        className={`${styles.noWrap} ${styles.jcc}`}
                                                        isSelected={sortState.sortParam === sortParamTypes.DOUBLESUTR}
                                                        sortType={sortState.sortType}
                                                        onClick={(srtType) => {
                                                            setSortState({
                                                                sortParam: sortParamTypes.DOUBLESUTR,
                                                                sortType: srtType,
                                                            });
                                                        }}
                                                        imgUrl="/img/v3/icons/icon-doubles-black.svg"
                                                        data-testid="draw-edit.players.col-doubles-utr"
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {(isPickleBallSportTypeEvent(sportTypeId)) && (
                                            <>
                                                <div className="col-md-2">
                                                    <ColumnHeader
                                                        isSortable
                                                        columnName="UTR-P"
                                                        className={`${styles.noWrap} ${styles.jcc}`}
                                                        isSelected={sortState.sortParam === sortParamTypes.SINGLESPKB}
                                                        sortType={sortState.sortType}
                                                        onClick={(srtType) => {
                                                            setSortState({
                                                                sortParam: sortParamTypes.SINGLESPKB,
                                                                sortType: srtType,
                                                            });
                                                        }}
                                                        imgUrl="/img/v3/icons/icon-singles-black.svg"
                                                        data-testid="draw-edit.players.col-singles-pkb"
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <ColumnHeader
                                                        isSortable
                                                        columnName="UTR-P"
                                                        className={`${styles.noWrap} ${styles.jcc}`}
                                                        isSelected={sortState.sortParam === sortParamTypes.DOUBLESPKB}
                                                        sortType={sortState.sortType}
                                                        onClick={(srtType) => {
                                                            setSortState({
                                                                sortParam: sortParamTypes.DOUBLESPKB,
                                                                sortType: srtType,
                                                            });
                                                        }}
                                                        imgUrl="/img/v3/icons/icon-doubles-black.svg"
                                                        data-testid="draw-edit.players.col-doubles-pkb"
                                                    />
                                                </div>
                                            </>
                                        )}

                                        <div className="col-md-1">
                                            <ColumnHeader
                                                isSortable
                                                columnName="Age"
                                                isSelected={sortState.sortParam === 'age'}
                                                sortType={sortState.sortType}
                                                onClick={(srtType) => {
                                                    setSortState({
                                                        sortParam: 'age',
                                                        sortType: srtType,
                                                    });
                                                }}
                                                data-testid="draw-edit.players.col-age"
                                            />
                                        </div>
                                        <div className="col-md-3 ps-3 text-dark" data-testid="draw-edit.players.col-contact">
                                            Contact
                                        </div>
                                    </div>
                                </div>
                                {isOneDivisionSelected ? (
                                    <div className="col-md-1">
                                        <ColumnHeader
                                            isSortable
                                            columnName={'Reg.st'}
                                            isSelected={sortState.sortParam === 'regStatus'}
                                            sortType={sortState.sortType}
                                            onClick={(srtType) => {
                                                setSortState({
                                                    sortParam: 'regStatus',
                                                    sortType: srtType,
                                                });
                                            }}
                                            data-testid="draw-edit.players.col-reg-status"
                                        />
                                    </div>
                                ) : (
                                    <div className="col-md-1 ps-3 text-dark" data-testid="draw-edit.players.col-reg-status">
                                        Reg.st
                                    </div>
                                )}
                                {isFlexLeagueEvent && (
                                    <div className="col-md-1 ps-3 text-dark" data-testid="draw-edit.players.col-home-court">
                                        Home Court
                                    </div>
                                )}
                                <div className="col-md-2 ps-3 text-dark" data-testid="draw-edit.players.col-division">
                                    Division
                                </div>
                                <div className="col-md-2 ps-3 text-dark" data-testid="draw-edit.players.col-draw">
                                    Draw
                                </div>
                                <div className="col-md-1" />
                            </div>
                        )}
                    </div>
                    <div className="all-players-list">
                        {isSingles && !!filteredPlayers.length && filteredPlayers.map(player => {
                            return (
                                <AllPlayersItemV3
                                    key={player.memberId}
                                    selected={selected.includes(player.memberId)}
                                    player={player}
                                    togglePlayerSelect={togglePlayerSelect}
                                    utrType={utrType}
                                    showMessage={true}
                                    onMessageClick={() => sendMessage(player)}
                                    setOrganizerRating={(memberId, type, rating, showPopup) => submitOrganizerRatings(memberId, type, rating, showPopup)}
                                    showMenuOptions={showPlayerMenuOptions && player.showPopOverOptions !== false}
                                    menuOptions={showPlayerMenuOptions && player.showPopOverOptions !== false ? playerOptions : []}
                                    onMenuSelected={(selectedOption, e) => playerMenuOnSelected(e, player.id, selectedOption)}
                                    showEdit={true}
                                    organizerRatings={organizerRatings}
                                    showOrganizerRatings={true}
                                    userIsPowered={true}
                                    sportTypeId={sportTypeId}
                                    showHighSchoolName={showHighSchoolName}
                                    user={props.auth?.user}
                                    drawsDict={drawsDict}
                                    isOneDivisionSelected={isOneDivisionSelected}
                                    isFlexLeagueEvent={isFlexLeagueEvent}
                                    showSaveBookmark={showSaveBookmark}
                                    data-testid={`draw-edit.players.item-${player.memberId}`}
                                />
                            );
                        })}
                        {!isSingles && !!filteredTeams.length && filteredTeams.map(team => {
                            return (
                                <AllPlayersTeamItemV3
                                    key={team.id}
                                    selected={selectedTeams.includes(team.id)}
                                    team={team}
                                    toggleTeamSelect={toggleTeamSelect}
                                    utrType={utrType}
                                    playersDictByMemberId={playersDictByMemberId}
                                    showEdit={true}
                                    setOrganizerRating={(memberId, type, rating, showPopup) => submitOrganizerRatings(memberId, type, rating, showPopup)}
                                    organizerRatings={organizerRatings}
                                    showOrganizerRatings={true}
                                    userIsPowered={true}
                                    sportTypeId={sportTypeId}
                                    showHighSchoolName={showHighSchoolName}
                                    user={props.auth?.user}
                                    drawsDict={drawsDict}
                                    isOneDivisionSelected={isOneDivisionSelected}
                                    isFlexLeagueEvent={isFlexLeagueEvent}
                                    showSaveBookmark={showSaveBookmark}
                                    data-testid={`draw-edit.players.team-${team.id}`}
                                />
                            );
                        })}
                        {!isLoading && ((isSingles && !filteredPlayers.length) || (!isSingles && !filteredTeams.length)) && (
                            <div className="text-center mt24" data-testid="draw-edit.players.no-results">There are no results matching your criteria.</div>
                        )}
                        {isLoading && (
                            <div className="text-center mt24" data-testid="draw-edit.players.loading">Loading Players...</div>
                        )}
                        {showLoadMoreBtn ? (
                            <div className="load-more-container">
                                <button className="btn btn-xl btn-block btn-primary" type="button" onClick={handleLoadMore} data-testid="draw-edit.players.load-more-btn">
                                    Load more
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            {playerWildcardPopup.show && (
                <PlayerWildcardPopup
                    memberId={playerWildcardPopup.memberId}
                    onCloseClick={closePlayerWildcardPopup}
                    onSubmit={submitPlayerWildcard}
                    options={acceptanceListWildcardStates}
                    data-testid="modal.draw-edit.player-wildcard"
                />
            )}
            {ratingExceptionPopup.show && (
                <Modal visible={true} onClickBackdrop={closeOrganizerRatingPopup}>
                    <div className="modal-header">
                        <div />
                        <div className="close-icon" onClick={closeOrganizerRatingPopup} data-testid="modal.draw-edit.rating-exception.close-btn"><i className="utr utr-close" /></div>
                    </div>

                    <div className={`modal-body`}>
                        <p className="mb24 text-center" data-testid="modal.draw-edit.rating-exception.message">This looks like it is far from our projections. Are you sure you would like to use this for draw placement?</p>
                        <div className="row">
                            <div className="col-md-6">
                                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={closeOrganizerRatingPopup} data-testid="modal.draw-edit.rating-exception.cancel-btn">Cancel</button>
                            </div>
                            <div className="col-md-6">
                                <button type="button" className={`btn btn-xl btn-block btn-default`} onClick={() => saveOrganizerRatings(ratingExceptionPopup.memberId, ratingExceptionPopup.type, ratingExceptionPopup.rating)} data-testid="modal.draw-edit.rating-exception.proceed-btn">Proceed</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
            {showContactForm && (
                <ContactForm
                    closeSidePanel={closeSidePanel}
                    selectedIndividualMemberIds={selected}
                    selectedMemberIdsFromTeams={membersList}
                    event={{ data: event }}
                    smsSendingDisabled={!smsAvailability.canSend}
                    smsSendingDisabledReason={smsAvailability.reason}
                    smsSendingDisabledCutoffDisplay={smsAvailability.cutoffDisplay}
                />
            )}
        </div>
    );
};

AllPlayersListV3.propTypes = {
    eventId: PropTypes.string,
    utrType: PropTypes.string.isRequired,
    sendMessage: PropTypes.func.isRequired,
    setMove: PropTypes.func.isRequired,
    sportTypeId: PropTypes.string.isRequired,
    showHighSchoolName: PropTypes.bool,
    filters: PropTypes.objectOf(any).isRequired,
    auth: PropTypes.objectOf(any).isRequired,
    filteredSortedTeams: PropTypes.objectOf(any).isRequired,
    filteredSortedPlayers: PropTypes.objectOf(any).isRequired,
    setSortState: PropTypes.func.isRequired,
    sortState: PropTypes.bool,
    isLoading: PropTypes.bool,
    hasLoadMore: PropTypes.bool,
    maxSortedTeams: PropTypes.objectOf(any).isRequired,
    maxSortedPlayers: PropTypes.objectOf(any).isRequired,
    setHasLoadMore: PropTypes.func.isRequired,
    hasLoadMoreButton: PropTypes.bool,
    isFlexLeagueEvent: PropTypes.bool,
};

AllPlayersListV3.defaultProps = {
    eventId: '',
    showHighSchoolName: false,
    sortState: '',
    hasLoadMore: false,
    isLoading: false,
    hasLoadMoreButton: false,
    isFlexLeagueEvent: false,
};

export default withAuth(AllPlayersListV3);
